import { http, createPublicClient } from "viem";
import { base, baseSepolia } from "viem/chains";

const chain =
	import.meta.env.VITE_NODE_ENV === "production" ? base : baseSepolia;
const network =
	import.meta.env.VITE_NODE_ENV === "production"
		? "base-mainnet"
		: "base-sepolia";

export const basePublicClient = createPublicClient({
	chain: base,
	transport: http(
		`https://base-mainnet.g.alchemy.com/v2/${
			import.meta.env.VITE_ALCHEMY_API_KEY
		}`,
	),
});

export const publicClient = createPublicClient({
	chain,
	transport: http(
		`https://${network}.g.alchemy.com/v2/${
			import.meta.env.VITE_ALCHEMY_API_KEY
		}`,
	),
});

export const CONTRACTS = {
	Treasury: {
		address: "0x6306E5DF3B668d7E26353706AF1aD50646D8E0e3",
	},
	"Buyback Executor": {
		address: "0x28ce5AF08c76428FC297B2645E0E2b54324318f0",
	},
	"NFT Minter": {
		address: "0x1d41dd2425aEa3e7dDbBdBE64e27138c05da3a82",
	},
	Inventory: {
		address: "0x39F56C7ed1dAD73F70a03AFC40c36C3752AC842c",
	},
	"Sale PXMCardGacha [USDC]": {
		address: "0xdB1462F1E5Ad03Ad4107e3Ba790892Cd93f5F484",
	},
	"Sale PXMCardGacha [Credits]": {
		address: "0xB6E7A655403001D1b215E0498320c83c5B57e0Af",
	},
	"Sale PXMBox [USDC]": {
		address: "0x1ACb4F375D60E596618ca2580AEBf184Dd52bE99",
	},
	"Sale PXMBox [Credits]": {
		address: "0x610C50DDB93dDB222b6fE47eA7c64f0aED5078D5",
	},
	"Box Gacha Contract": {
		address: "0xED50c38f6CD4BC894c973DD30Cd134f95949b9E5",
	},
	"Card Gacha Contract": {
		address: "0x4891de2873F05bcCEEEd46Aa1F5D8f41dc951e9c",
	},
	"Ledger Marketplace Wallet": {
		address: "0x9a05Fd49F1216Af825564e77D9477d72592cc9f3",
	},
	"CC Payment Minter Wallet": {
		address: "0x7D61275AE9B9671E0990ED8431C7FF2Ae0ec1057",
	},
} as const;
